import React from "react";
import {
  FaClock,
  FaTools,
  FaShieldAlt,
  FaHome,
  FaMoneyBillWave,
  FaUserCheck,
} from "react-icons/fa";

import "./WhyChooseUs.css";

function WhyChooseUs() {
  const features = [
    {
      icon: <FaClock />,
      title: "Same Day Repair",
      description:
        "Most repairs are completed within the same day at your location.",
    },
    {
      icon: <FaHome />,
      title: "Doorstep Service",
      description:
        "Our technician comes directly to your home, office, or preferred location.",
    },
    {
      icon: <FaTools />,
      title: "Expert Technicians",
      description:
        "Experienced professionals trained to repair all major smartphone brands.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Warranty Included",
      description:
        "All repairs come with warranty coverage for your peace of mind.",
    },
    {
      icon: <FaMoneyBillWave />,
      title: "Transparent Pricing",
      description:
        "No hidden charges. Get clear pricing before any repair begins.",
    },
    {
      icon: <FaUserCheck />,
      title: "Customer Satisfaction",
      description:
        "Hundreds of happy customers trust us for reliable mobile repairs.",
    },
  ];

  return (
    <section className="why-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Why Choose Us</span>

          <h2 className="section-title">
            Trusted Mobile Repair Service Across UAE
          </h2>

          <p className="section-description">
            We provide professional mobile repair services with convenience,
            reliability, and customer satisfaction at the core of everything we
            do.
          </p>
        </div>

        <div className="row">
          {features.map((feature, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 mb-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              data-aos-duration="1000"
            >
              <div className="why-card">
                <div className="why-icon">{feature.icon}</div>

                <h4>{feature.title}</h4>

                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
